export const DEFAULT_API_BASE = '/api'
export const AUTH_LOGIN_PATH = '/auth/login'
export const AUTH_SESSION_PATH = '/auth/me'
export const AUTH_LOGOUT_PATH = '/auth/logout'

export const AUTH_APPS = ['frontend', 'admin', 'forge', 'folio', 'vhoop'] as const
export type AuthApp = (typeof AUTH_APPS)[number]
